import { useEffect,useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Alert, Button, Card, CardContent, Grid } from '@mui/material'
import { post } from '../../../utils/axios'
import { toast } from 'react-toastify'

const Index = () => {

    const navigate = useNavigate()

    const [rows,setRows] = useState([])
    const [fetchedData,setFetchedData] = useState(false)

    useEffect(() => {
        post('Support/GetRequest',{offset: 0,limit: 5000}).then(({ data }) => {
            if(data.isSuccess)
                setRows(data.data)
        }).finally(() => {
            setFetchedData(true)
        })
    },[])

    const copyNo = no => {
        if(no){
            navigator.clipboard.writeText(no.toString())
            toast.success('شماره درخواست با موفقیت کپی شد')
        }
    }

    return (
        <Grid item px={0.3} sx={{position: 'relative'}}>
            <h3 className="others-page-title">درخواست های پشتیبانی و شکایات</h3>
            <div className="safe-area">
                <Button className="btn-plus-item" variant="contained" onClick={() => navigate('/app/tickets/add')}><i className="fal fa-plus"></i></Button>
                <Grid sx={{mb: 5}}>
                    {rows.length ? rows.map(item => (<Card sx={{width: '100%',mb: 2}}>
                        <CardContent sx={{pt: 3}}>
                            <Grid container spacing={2}>
                                <Grid item xs={6} onClick={() => navigate(`/app/tickets/${item.id}`)}>
                                    <p style={{fontSize: 15}} onClick={() => copyNo(item.requestNo)}>درخواست {item.requestNo}</p>
                                </Grid>
                                <Grid item xs={4} onClick={() => navigate(`/app/tickets/${item.id}`)}>
                                    {item.status == 1 ? <p style={{textAlign: 'left',fontSize: 14,color: '#7e165c'}}>ثبت شده</p> : ''}
                                    {item.status == 2 ? <p style={{textAlign: 'left',fontSize: 14,color: 'green'}}>پاسخ داده شده</p> : ''}
                                    {item.status == 3 ? <p style={{textAlign: 'left',fontSize: 14,color: 'red'}}>بسته شده</p> : ''}
                                </Grid>
                                <Grid item xs={2} onClick={() => navigate(`/app/tickets/${item.id}`)}>
                                    <p style={{textAlign: 'left',fontSize: 14,color: '#217bdb'}}>مشاهده</p>
                                </Grid>
                                <Grid xs={12} sx={{ px: 2,mt: 2 }}>
                                    <p style={{fontSize: 14}}>متن درخواست : {item.supportTickets[0].ticketMessage.slice(0,25)} {item.supportTickets[0].ticketMessage.length > 25 ? ' ...' : ''}</p>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>)) : (fetchedData ? <Alert variant="standard" color="info">درخواستی ثبت نکرده اید</Alert> : [...Array(3)].map((item,index) => <Card key={index} sx={{width: '100%',mb: 2}}>
                        <CardContent sx={{py: 3,pb: 4}}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <p className="order-item-detail-placeholder animate"></p>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>))}
                </Grid>
            </div>
        </Grid>
    )
}

export default Index